import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  heading: {
    marginBottom: '6px',
  },
  description: {
    marginBottom: '16px',
  },
  fieldLabel: {
    marginBottom: '4px',
  },
});
